module.exports = __webpack_public_path__ + "img/logo.07511b8a.png";